import React from "react";
import {Link} from "react-router-dom";

const sidebarFooter = () => {
    return (
        <div className="d-flex flex-column ms-auto  ">
            <p className="fs-xs mb-0 text-end">Vibe24Cafe &copy; 2025</p>
            <p className="fs-xs mb-0 text-end"><Link to={"#"}>Terms of use</Link> & <Link to={"#"}>Privacy Policy</Link></p>
        </div>
    )
}
export default sidebarFooter;
